<template>
    <v-form>
        <v-progress-linear indeterminate v-if="loading"/>
        <v-container grid-list-md>
            <v-layout align-center class="mb-3">
                <div class="headline" v-if="notification.id">Rediger push-melding</div>
                <div class="headline" v-else>Ny push-melding</div>

                <v-spacer/>

                <v-btn :to="{name: 'Index'}">
                    <v-icon left>arrow_back</v-icon>
                    Tilbake
                </v-btn>
            </v-layout>

            <v-layout>
                <v-flex md8>
                    <v-text-field class="mb-3" solo v-model="notification.title" hint="Overskrift" label=" "
                                  persistent-hint
                                  :counter="40" required/>
                    <v-text-field solo v-model="notification.message" hint="Meldingstekst" label=" " persistent-hint
                                  :counter="100" required/>

                    <v-divider class="my-3"/>

                    <v-radio-group v-model="notificationType">
                        <v-radio value="single" label="Send som engangsmelding"/>
                        <v-radio value="recurring" label="Send som repeterende melding"/>
                    </v-radio-group>
                </v-flex>
                <v-flex md4>
                    <v-card class="mb-4 ml-2">
                        <v-subheader>Hjelp</v-subheader>
                        <v-card-text class="pt-0">
                            Herfra kan du planlegge push-meldinger som sendes ut til de som bruker appen. Du kan sette
                            opp
                            engangsmeldinger eller repeterende meldinger.
                        </v-card-text>
                        <v-card-text class="pt-0">
                            Det kan ta 1-2 minutter fra meldingen lagres her, til den sendes ut i appen. Kun meldinger
                            som
                            settes med sende-tidspunkt fram i tid, vil bli sendt. Du bør derfor sette sendetidspunkt
                            minst fem
                            minutter fram.
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <div v-if="notification.recurrences">
                <v-subheader>Frekvens for utsending: (repeterende utsending)</v-subheader>
                <rrule v-model="notification.recurrences"/>
            </div>
            <div v-else>
                <v-card class="px-3 py-3">
                    <v-datetime-picker label="Tidspunkt for utsending (en gang)" format="DD.MM.YYYY HH:mm"
                                       clear-text="Tøm" locale="nb" hide-details :first-day-of-week="1"
                                       v-model="notification.datetime"/>
                </v-card>
            </div>

            <v-divider class="my-3"/>

            <v-layout>
                <v-btn @click="save" color="green" dark>Lagre</v-btn>
                <v-btn @click="remove" color="red" dark v-if="notification.id">Slett</v-btn>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import Rrule from "../components/Rrule";
    import axios from "axios";

    export default {
        components: {
            Rrule
        },

        created() {
            let id = this.$route.params.id;
            if (id) {
                this.loadData(id);
            }
        },

        data() {
            return {
                loading: false,
                notification: {
                    time: '16:00',
                    recurrences: null
                }
            }
        },

        methods: {
            loadData(notificationId) {
                this.loading = false;
                axios.get(`/api/notifications/${notificationId}/`).then(response => {
                    this.notification = response.data;
                }).finally(() => {
                    this.loading = false;
                });
            },

            save() {
                let request;
                if (this.notification.id) {
                    request = axios.put(`/api/notifications/${this.notification.id}/`, this.notification);
                } else {
                    request = axios.post('/api/notifications/', this.notification);
                }

                this.loading = true;
                request.then(response => {
                    this.notification = response.data;
                    this.$snackbar.success('Lagring vellykket.');
                }).catch(() => {
                    this.$snackbar.error('Lagring feilet.');
                }).finally(() => {
                    this.loading = false;
                });
            },
            remove() {
                let ok = confirm('Vil du slette denne push-meldingen?');
                if (!ok) return;

                axios.delete(`/api/notifications/${this.notification.id}`).then(response => {
                    this.$router.push({name: 'Index'});
                    this.$snackbar.info('Sletting vellykket.');
                });
            }
        },

        computed: {
            notificationType: {
                get() {
                    if (this.notification.recurrences) return 'recurring';
                    return 'single';
                },
                set(value) {
                    if (value === 'recurring') {
                        this.notification.recurrences = 'FREQ=DAILY;INTERVAL=1;COUNT=2;BYHOUR=16;BYMINUTE=00';
                        this.notification.time = null;
                    } else {
                        this.notification.recurrences = null;
                        this.notification.time = '16:00';
                    }
                }
            }
        }
    }
</script>